const menu = [
  {
    id: 1,
    title: 'flan',
    category: 'desserts',
    price: 3.99,
    img: './images/item-1.jpg',
    desc: `This is a pudding with wobbly consistency and sticky sweet caramel sauce on the top. Flan was actually invented by the Romans and was first popularized in Spain before it found its way to the Americas. `,
  },
  {
    id: 2,
    title: 'diner double',
    category: 'lunch',
    price: 5.99,
    img: './images/item-2.jpeg',
    desc: `Two chicken patties, a slice of cheese, lettuce, pickles served with fries and the sauce.  `,
  },
  {
    id: 3,
    title: 'Chocolate Banana Milkshake',
    category: 'shakes',
    price: 2.99,
    img: './images/item-3.png',
    desc: `This milkshake has a great balance of milk to ice cream, and I like the half of a banana so it doesn't become too overpowering`,
  },
  {
    id: 4,
    title: 'cheesecake',
    category: 'desserts',
    price: 2.99,
    img: './images/item-4.jpg',
    desc: `Pay de Queso is the phonetic Spanish spelling of the English word pie. This dish is known by its more common name, cheesecake. It is a popular dessert in Mexico, the United States, and across the world. `,
  },
  {
    id: 5,
    title: 'egg attack',
    category: 'lunch',
    price: 4.99,
    img: './images/item-5.jpeg',
    desc: `A burger made with a juicy plant-based patty featuring sandwich sauce, ketchup, mustard, onion, pickles, lettuce, tomato, and a vegan alternative to cheese in a sesame seed bun. `,
  },
  {
    id: 6,
    title: 'oreo dream',
    category: 'shakes',
    price: 4.99,
    img: './images/item-6.jpeg',
    desc: `It's combined with vanilla ice cream, milk, chocolate sauce, oreos and whipped cream for topping`,
  },
  {
    id: 7,
    title: 'chimichangas',
    category: 'desserts',
    price: 3.99,
    img: './images/item-7.jpg',
    desc: `It’s just a deep fried burrito, so the filling options are endless, including sweet cinnamon apples, deep fried, and served with a scoop of vanilla ice cream. `,
  },
  {
    id: 8,
    title: 'american classic',
    category: 'lunch',
    price: 3.99,
    img: './images/item-8.jpeg',
    desc: `A sausage patty seasoned with herbs, a free-range egg, two slices of bacon and a slice of cheese served in a toasted English muffin with either tomato ketchup or brown sauce.  `,
  },
  {
    id: 9,
    title: 'georgia shake',
    category: 'shakes',
    price: 3.99,
    img: './images/item-9.png',
    desc: `Peanut butter cups are blended with chocolate ice cream and milk to make this indulgent treat. Garnish with another crumbled cup to take it over the top.`,
  },
  {
    id: 10,
    title: 'fried ice cream',
    category: 'desserts',
    price: 2.59,
    img: './images/item-10.jpg',
    desc: `A scoop of ice cream is deep fried, and served in a crispy cinnamon coated flour tortilla shell, topped with whipped cream and a cherry. `,
  },
  {
    id: 11,
    title: 'american classic',
    category: 'lunch',
    price: 1.99,
    img: './images/item-11.jpg',
    desc: `Two 100% beef patties, two rashers of Beechwood smoked bacon, two slices of cheese, onions, pickles, mustard and tomato ketchup, all in a soft bun.  `,
  },
  {
    id: 12,
    title: 'yummy strawberry shake',
    category: 'shakes',
    price: 2.99,
    img: './images/item-12.png',
    desc: `This traditional strawberry shake uses just five simple ingredients: fresh strawberries, ice, milk, strawberry ice cream, and sugar.`,
  }
];
export default menu;
